// reducers/agentReducer.ts
import {
    ADD_TOOLS_REQUEST,
    ADD_TOOLS_SUCCESS,
    ADD_TOOLS_FAILURE
} from '../../actions';

interface ToolState {
    loading: boolean;
    data: any;
    error: string | null;
}

const initialState: ToolState = {
    loading: false,
    data: null,
    error: null
};

const addToolsReducer = (state = initialState, action: any): ToolState => {
    switch (action.type) {
        case ADD_TOOLS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case ADD_TOOLS_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null
            };
        case ADD_TOOLS_FAILURE:
            return {
                ...state,
                loading: false,
                data: null,
                error: action.error
            };
        default:
            return state;
    }
};

export default addToolsReducer;
